import { __values } from "tslib";
import { isString, isObject, isFunction, isArray } from "./check";
import { mergeBeforeSend } from "./merge";
export function generateOption(option) {
    if (isString(option) && isValidDsn(option)) {
        return {
            dsn: option
        };
    }
    else if (isObject(option) && isValidDsn(option.dsn)) {
        return option;
    }
    return {};
}
export function prepareSendHook(options, defaultOptions) {
    var beforeSend = options.beforeSend; // 可能同时传了 wjBeforeSend 和 beforeSend 这时候要合并方法, wjBeforeSend优先级应该高一点
    var mergeBeforeSended;
    if (beforeSend) {
        delete options.beforeSend;
        mergeBeforeSended = beforeSend;
    }
    if (isObject(defaultOptions) && isFunction(defaultOptions.beforeSend)) {
        if (isFunction(mergeBeforeSended)) {
            mergeBeforeSended = mergeBeforeSend(mergeBeforeSended, defaultOptions.beforeSend);
        }
        else {
            mergeBeforeSended = defaultOptions.beforeSend;
        }
        delete defaultOptions.beforeSend;
    }
    if (isFunction(mergeBeforeSended)) {
        return mergeBeforeSended;
    }
    return function (ev) { return ev; };
}
export function prepareFilterHook(options) {
    var filter = options === null || options === void 0 ? void 0 : options.wj_filter;
    var filterStrArr = [];
    if (isString(filter)) {
        filterStrArr = [filter];
    }
    else if (isArray(filter)) {
        filterStrArr = filter;
    }
    else {
        return function () { return false; };
    }
    return function (hint) {
        var e_1, _a;
        var _b;
        var stackStr = (_b = hint === null || hint === void 0 ? void 0 : hint.originalException) === null || _b === void 0 ? void 0 : _b.stack;
        if (!stackStr)
            return false;
        var isHit = false;
        try {
            for (var filterStrArr_1 = __values(filterStrArr), filterStrArr_1_1 = filterStrArr_1.next(); !filterStrArr_1_1.done; filterStrArr_1_1 = filterStrArr_1.next()) {
                var filterStr = filterStrArr_1_1.value;
                if (stackStr.indexOf(filterStr) >= 0) {
                    isHit = true;
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (filterStrArr_1_1 && !filterStrArr_1_1.done && (_a = filterStrArr_1.return)) _a.call(filterStrArr_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return isHit;
    };
}
export function isValidDsn(dsn) {
    return /^https?:\/\/[a-z0-9A-Z]+@.+\/.+/.test(dsn);
}
//# sourceMappingURL=generate-option.js.map